import { useEffect } from 'react';
import { initDebugHelpers } from '@utils/debugMerged';
import { initConsoleCapture } from '@utils/consoleCapture';

/**
 * Componente "headless" que solo se renderiza en desarrollo
 * para inicializar herramientas de depuración globales.
 */
export default function DebugInitializer() {
  useEffect(() => {
    // La lógica se ejecuta una sola vez cuando el componente se monta.
    initDebugHelpers();
    initConsoleCapture();
  }, []); // Array vacío para asegurar una única ejecución.

  // No renderiza nada en la UI
  return null;
}